import { PickListDesignTokens } from '@primeuix/themes/aura/picklist';

export const pickListTokens: PickListDesignTokens = {
  root: {
    gap: '1.125rem',
  },
  controls: {
    gap: '0.5rem',
  },
};
